import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import IconButton from '@material-ui/core/IconButton'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import {bindActionCreators} from 'redux'
import {showDrawer} from '../../../ducks/views'
import {connect} from 'react-redux'
import {drawers} from '../../drawer-component-mapping'
import { addBarrierSourceTypeEntry, modifyBarrierSourceTypeEntry } from '../../../graphql/relay/queries/barrierSourceType'
import BarrierSourceTypeTable from './BarrierSourceTypeTable'
import {createFragmentContainer, graphql} from 'react-relay'
import cloneDeep from 'lodash.clonedeep'


function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        showDrawer
      },
      dispatch
    ),
  }
}

const BarrierSourceTypeEditor = ({ barrierSourceTypeConfigs, barrierSourceDetailConfigs, actions }) => {

  const handleAdd = () => {
    const drawerTitle = "Create a Barrier Source Type"
    const data = {
      code: '',
      value: '',
      ordinal: getMaxSortOrder(),
      active: true,
      activeDirectorySourceName: false,
      sourceDetails: setupSourceDetails(barrierSourceDetailConfigs, [])
    }
    openDrawer(drawerTitle, false, data, addBarrierSourceTypeEntry)
  }

  const handleEdit = (entry) => {
    const drawerTitle = "Edit a Barrier Source Type"
    const data = {
      ...entry,
      sourceDetails: setupSourceDetails(barrierSourceDetailConfigs, entry.sourceDetails)
    }
    openDrawer(drawerTitle, true, data, modifyBarrierSourceTypeEntry)
  }

  const setupSourceDetails = (barrierSourceDetailConfigs, selectedSourceDetails) => {
    const sourceDetailConfigCopy = cloneDeep(barrierSourceDetailConfigs)
    return sourceDetailConfigCopy.map(type => {
      const isSelected = selectedSourceDetails.find(selectedSource => selectedSource.code === type.code)
      return {...type, isSelected: !!isSelected}
    })
  }

  const openDrawer = (drawerTitle, isEdit, data, mutation) => {
    actions.showDrawer(drawers.BARRIER_SOURCE_TYPE_DRAWER, {
      title: drawerTitle,
      isEdit,
      data,
      mutation
    })
  }

  const getMaxSortOrder = () => {
    const sortArray = barrierSourceTypeConfigs.map(item => item.ordinal)
    const max = Math.max(...sortArray)
    return max ? max + 1 : 1
  }

  return (
    <StyledWrapperDiv>
      <StyledTitleSection>
        <h1>Barrier Source Types</h1>
        <StyledAddButton onClick={handleAdd}>
          <AddCircleOutlineIcon/>
        </StyledAddButton>
      </StyledTitleSection>
      <BarrierSourceTypeTable barrierSourceTypeConfigs={barrierSourceTypeConfigs} onEdit={handleEdit} />
    </StyledWrapperDiv>
  )
}

const StyledWrapperDiv = styled.div`
  padding: 20px 20px 0 20px;

  svg {
    font-size: 24px;
  }
`

const StyledTitleSection = styled.div`
  display: flex;
  align-items: center;

  h1 {
    margin: 0;
  }
`

const StyledAddButton = styled(IconButton)`
  && {
    padding: 8px;
    height: 40px;
    width: 40px;
  }
`

BarrierSourceTypeEditor.propTypes = {
  barrierSourceTypeConfigs: PropTypes.array,
  barrierSourceDetailConfigs: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      value: PropTypes.string,
      ordinal: PropTypes.number,
      active: PropTypes.bool,
    })
  ),
  actions: PropTypes.shape({
    showDrawer: PropTypes.func
  }),
}

const BarrierSourceTypeEditorRedux = connect(null, mapDispatchToProps)(BarrierSourceTypeEditor)
export default createFragmentContainer(BarrierSourceTypeEditorRedux, {
  barrierSourceDetailConfigs: graphql`
    fragment BarrierSourceTypeEditor_barrierSourceDetailConfigs on CodeTable @relay(plural: true) {
      id
      code
      value
      ordinal
      active
    }
  `,
  barrierSourceTypeConfigs: graphql`
    fragment BarrierSourceTypeEditor_barrierSourceTypeConfigs on BarrierSourceType @relay(plural: true) {
      ...BarrierSourceTypeTable_barrierSourceTypeConfigs
      ordinal
    }
  `
})
